function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './ItineraryDayViewHeader.css';
import React from 'react';
import { get, canUseDOM } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
// import GoogleMap, { defaultMapState, googleMapDirectionLink } from '../atoms/GoogleMaps/GoogleMaps';
import { getPlaceInfoByIDPromise } from '../atoms/GoogleMaps/GooglePlaceService';
// import OSM from '../atoms/OpenStreetMap/OpenStreetMap';

import loadable from '@loadable/component';
const OSM = loadable(() => import('../atoms/OpenStreetMap/OpenStreetMap'), {
  ssr: false
});
const staticMap = 'https://maps.googleapis.com/maps/api/staticmap';
const markerUrl = '/dist/inventory/assets/images/marker.png';
export const ItineraryDayViewHeader = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const currentLang = get(sitecoreContext, 'language');
  const googleApiKey = get(sitecoreContext, 'configuration.google.apiKey', '');
  /* const newWindowLabel: string = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window"; */
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const ColorHex = '#525252';
  /* const ActiveColorHex = get(params, 'ActiveColorHex', '--main-color--active'); */
  const ActiveColorHex = get(params, 'BackgroundColorHex', '--main-color');
  const activeItemID = get(fields, 'data.item.activeItemId');
  const daysItems = get(fields, 'data.item.days.values');
  const [currentItem, setCurrentItem] = React.useState();
  const [title, setTitle] = React.useState('');
  const [locationsCount, setLocationsCount] = React.useState(0);
  const [mapApiReady, setMapApiReady] = React.useState(false);
  const [isChina, setIsChina] = React.useState();
  const [GoogleMap, setGoogleMap] = React.useState(null);
  const [googleMapImg, setGoogleMapImg] = React.useState('');
  const [markersMap, setMarkersMap] = React.useState([]);
  const [mapState, setMapState] = React.useState({
    lat: 25.2048493,
    lng: 55.2707828,
    activeMarker: 0,
    markers: [{}],
    vis: false
  });
  React.useEffect(() => {
    const urlParams = new URLSearchParams(document.location.search);
    const isC = Boolean(urlParams.get('isChina') === 'true');
    setIsChina(isC);
    if (daysItems) {
      daysItems.map(item => {
        if (activeItemID === item.id) {
          setCurrentItem(item);
          setMarkersMap(item.pois.values);
          setTitle(item.title.jss.value);
          setLocationsCount(item.pois.values.length);
          updateLocations(item);
        }
      });
    }
  }, [mapApiReady]);
  const placeInfoRef = React.useRef(null);
  const updateLocations = async item => {
    if (item) {
      const markersPromArr = item.pois.values.map(async item => {
        const title = get(item, 'title.jss.value');
        const googlePlaceId = get(item, 'googlePlaceID.jss.value');
        let lat = get(item, 'latitude.jss.value');
        let lng = get(item, 'longitude.jss.value');
        if (!isChina && googlePlaceId && mapApiReady) {
          const place = await getPlaceInfoByIDPromise(googlePlaceId, placeInfoRef.current);
          lng = place && place.geometry && place.geometry.location && place.geometry.location.lng();
          lat = place && place.geometry && place.geometry.location && place.geometry.location.lat();
        }
        return {
          lng,
          lat,
          title
        };
      });
      Promise.all(markersPromArr).then(markers => {
        // default map center is first valid marker in array
        const {
          lat,
          lng
        } = markers.find(_ref2 => {
          let {
            lat,
            lng
          } = _ref2;
          return lat && lng;
        });
        setMapState(_objectSpread(_objectSpread({}, mapState), {}, {
          vis: true,
          activeMarker: 0,
          lat,
          lng,
          markers
        }));
      });
    }
  };
  const apiReady = () => {
    setTimeout(() => {
      setMapApiReady(true);
    }, 2000);
  };
  const markerCallback = () => {};
  React.useEffect(() => {
    setTimeout(() => {
      setGoogleMap(loadable(() => import('../atoms/GoogleMaps/GoogleMaps'), {
        ssr: false
      }));
    }, 2000);
  }, []);
  const loc = canUseDOM ? window.location.host : '';
  React.useEffect(() => {
    console.log(`icon:${'http://' + loc + markerUrl}`);
    // const markers = markersMap.reduce((accumulator: string, marker: any) =>
    //     `${accumulator}&markers=icon:${'http://' + loc + markerUrl}%7C${marker.latitude.jss.value},${marker.longitude.jss.value}`
    //     , '');
    // setGoogleMapImg(`${staticMap}?language=en&center=${mapState.lat},${mapState.lng}&zoom=10&size=1180x590${markers}&key=${googleApiKey}`);
  }, [markersMap, mapState.lat, mapState.lng]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group remove-padding-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row d-md-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__title h2"
  }, title))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-10 offset-xl-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__map-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__map-wrapper-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__map"
  }, /*#__PURE__*/React.createElement("div", {
    ref: placeInfoRef,
    id: "place-info"
  }), /*#__PURE__*/React.createElement("div", {
    className: `header-mv__map_block ${mapApiReady ? 'visible' : 'invisible'}`
  }, !isChina && GoogleMap && /*#__PURE__*/React.createElement(GoogleMap, {
    language: currentLang,
    mapKey: googleApiKey,
    disableBound: true,
    zoom: 10,
    callback: apiReady,
    mapState: mapState,
    theme: _objectSpread(_objectSpread({}, get(sitecoreContext, 'themesOfPage')), {
      primary: mapState.markers.length > 1 ? ColorHex : ActiveColorHex,
      primary_active: ActiveColorHex
    })
  })), !mapApiReady && googleMapImg && /*#__PURE__*/React.createElement("img", {
    src: googleMapImg,
    className: "map-img visible",
    alt: ""
  }), isChina && /*#__PURE__*/React.createElement(OSM, {
    zoom: 9,
    customMarker: false,
    callback: apiReady,
    markerCallback: markerCallback,
    mapState: mapState
  })), /*#__PURE__*/React.createElement("div", {
    className: "header-mv__controls"
  }, /*#__PURE__*/React.createElement("span", {
    className: "my-icon-white header-mv__controls-btn"
    //target="_blank"
    //rel="noopener noreferrer"
    //aria-label={`${title} | ${newWindowLabel}`}
    //   href={googleMapDirectionLink(mapState.lat, mapState.lng)}
  }, /*#__PURE__*/React.createElement("svg", {
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "21",
    viewBox: "0 0 22 21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--main-color)",
    fillRule: "nonzero",
    d: "M9.707 0a2 2 0 0 0 0 2.828l.879.879H3c-1.654 0-3 1.346-3 3v6h2v-6c0-.551.449-1 1-1h7.586l-.879.879a2 2 0 0 0 0 2.828l4.707-4.707L9.707 0z",
    transform: "translate(4 2)"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "header-mv__overlay"
  }, title && /*#__PURE__*/React.createElement("h1", {
    className: "d-none d-md-block header-mv__title h2"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "header-mv__labels-sec"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__labels-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__label"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-mv__label-icon"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16.093",
    height: "19.71",
    viewBox: "0 0 16.093 19.71"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-76.508 -194.206)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57",
    transform: "translate(76.758 193.961)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 107",
    d: "M84.4,193.964a7.6,7.6,0,0,0-7.639,7.2v.038c.125,4.366,3.95,8.393,7.335,11.755a.754.754,0,0,0,1.062-.019c3.132-3.372,7.275-7.026,7.195-11.943v0a7.555,7.555,0,0,0-7.954-7.033Zm.026,1.3a6.155,6.155,0,0,1,6.509,5.763C91,205,87.67,208.253,84.617,211.492c-3.168-3.2-6.32-6.842-6.43-10.3a6.178,6.178,0,0,1,6.236-5.93Z",
    transform: "translate(-76.758 -193.466)",
    fill: "var(--main-color)",
    stroke: "var(--main-color)",
    "stroke-width": "0.5"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 78",
    cx: "2",
    cy: "2",
    r: "2",
    transform: "translate(6 6)",
    fill: "var(--main-color)"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "header-mv__label-text"
  }, locationsCount, " ", mapDictionary.get('Places'))))))))))))))))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${headerCommonStyle} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const headerCommonStyle = "h1fy3op8";
const ltrStyles = "le85g9k";
const rtlStyles = "r1eg9nxl";
export default ItineraryDayViewHeader;